// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__38K64","consentsList":"PatientConsents_consentsList__2RYEl","consentsListEmpty":"PatientConsents_consentsListEmpty__2wCMX"};